import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={32} height={43} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="M15.58.5c7.671 0 13.784 4.499 13.784 11.354 0 3.212-1.28 5.887-3.278 7.88 2.86 2.116 4.574 5.414 4.574 9.346 0 7.754-6.575 12.92-15.08 12.92C7.02 42 .5 36.833.5 29.08c0-3.931 1.713-7.23 4.573-9.347-1.997-1.992-3.277-4.668-3.277-7.88C1.796 5 7.853.5 15.58.5Zm0 23.356c-1.587 0-2.832.527-3.68 1.356-.847.83-1.328 1.993-1.328 3.328 0 1.418.495 2.577 1.343 3.384.85.808 2.097 1.3 3.665 1.3 1.54 0 2.787-.49 3.646-1.301.856-.809 1.362-1.969 1.362-3.383 0-1.335-.48-2.498-1.328-3.328-.847-.83-2.093-1.355-3.68-1.356Zm0-14.904c-2.48 0-4.306 1.611-4.306 3.874 0 2.266 1.776 3.874 4.306 3.874 1.27 0 2.332-.41 3.071-1.085.737-.671 1.181-1.629 1.181-2.789 0-2.266-1.83-3.874-4.252-3.874Z"
        />
    </Svg>
);
export { SvgComponent as EightIcon };
